namespace Umbrella.Modules.Repairs {
    export interface ILocationTypeCodeResourceClass {
        getAll(): ng.resource.IResource<LocationTypeCodeModel[]>;
        getPaged(
            params: PagedRequestParams
        ): ng.resource.IResource<PagedItemsModel<LocationTypeCodeModel>>;
        getById(
            params: IdRequestParams
        ): ng.resource.IResource<LocationTypeCodeModel>;
    }

    angular.module('Repairs').service('LocationTypeCodeResource', [
        '$resource',
        $resource =>
            $resource(
                '/api/v1/locationtypecode/:action/:id',
                {},
                {
                    getAll: {
                        method: 'GET',
                        isArray: true,
                        params: {}
                    },
                    getById: {
                        method: 'GET',
                        isArray: false,
                        params: {}
                    },
                    getPaged: {
                        method: 'GET',
                        isArray: false,
                        params: { action: 'getPaged', page: 0, pageSize: 10 }
                    },
                    update: {
                        method: 'PUT',
                        isArray: false,
                        params: {}
                    },
                    save: {
                        method: 'POST',
                        isArray: false,
                        params: {}
                    },
                    delete: {
                        method: 'DELETE',
                        isArray: false,
                        params: { id: '' }
                    }
                }
            )
    ]);
}
